export default __webpack_public_path__ + "static/media/GFiguradoOpen.6b66e374.jpg";